import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Menu, Tooltip } from '@mui/material';

// Components
import { ModelList } from '../../../components/PaginatedList/ModelList';
import { OrderBy } from '../../../components/QueryBuilder/OrderBy';

// Styles
import { SmartContainer, HorizontalStack } from '../../../styles/Containers'
import { StyledIconButton } from '../../../styles/matieralui/IconButton';
import { DefaultContentCard } from '../../components/Content/DefaultContentCard';
import { DefaultContentCardList } from '../../components/Content/DefaultContentCardList';
import { EmptyList } from '../../components/Empty/EmptyList';
import { IconFeed, IconGrid } from '../../Icons';
import { TERM_ALBUM, hasAccess } from '../../services/CaptureCollabService';
import { createAlbum, restoreAlbum, restoreLibrary, searchAlbum, searchLibrary } from './redux/album.actions';
import { FullAlbums } from './redux/album.selectors';
import { DateRange } from '../../../components/QueryBuilder/DateRange';
import moment from 'moment';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { DateRangeOutlined, LocalConvenienceStoreOutlined } from '@mui/icons-material';
import { StyledP } from '../../../styles/StyledHTML';
import { SortBy } from '../../components/Search/SortBy';
import { FullUI } from '../../../redux/UI/ui.selectors';
import { FilterDateRange } from '../../components/Search/FilterDateRange';


export const AlbumList = ({ onSelect, filters = null, prepend = false, libraryId }) => {

    // New Modal
    const dispatch = useDispatch();
    const ui = FullUI();
    const [view, setView] = useState('all');
    const [order, setOrder] = useState({ column: 'createdAt', direction: 'DESC' });
    const [range, setRange] = useState(null);

    const [grid, setGrid] = useState(true);
    const store = FullAlbums();

    const [dateAnchor, setDateAnchor] = useState(null);

    useEffect(() => {
        // Set Default Sort
        if (ui?.sortAlbums) setOrder(ui.sortAlbums);
        if (ui?.filterAlbumsByDate) setRange(ui.filterAlbumsByDate)
    }, [])


    // --------------------------
    // Interactions
    // --------------------------

    // On Select
    const handleSelect = (item) => onSelect(item);
    const renderEmpty = () => {

        return (
            <SmartContainer>
                <EmptyList model={TERM_ALBUM} buttonText={`Create a New ${TERM_ALBUM}`} label={`New ${TERM_ALBUM}`} selector={FullAlbums} createAction={createAlbum} args={{ LibraryId: libraryId }} />
            </SmartContainer>
        )
    }

    const renderMediaCard = (item, onClickItem) => {
        if (!grid) return (<DefaultContentCardList content={item} onClick={onClickItem} filters={filters} model="Album" />)
        return (<DefaultContentCard content={item} onClick={onClickItem} filters={filters} model="Album" />)
    }

    const renderCustomControls = () => {
        return (
            <HorizontalStack width="100%" flex align="center" justify="end">
                <SortBy storageKey="sortAlbums" options={['name', 'createdAt']} value={order} onChange={setOrder} />
                <FilterDateRange storageKey="filterAlbumsByDate" value={range} onChange={setRange} />
                <SmartContainer>
                    <Tooltip title="List or Grid View" placement="top">
                        <StyledIconButton onClick={() => setGrid(!grid)}>
                            {!grid && (<IconGrid />)}
                            {grid && (<IconFeed />)}
                        </StyledIconButton>
                    </Tooltip>
                </SmartContainer>
            </HorizontalStack>
        )
    }

    const variant = (grid) ? 'cards' : 'list';

    const formatOtherFilters = () => {

        // Clone Filters
        const x = { ...filters };

        // Order By
        if (order?.column) x.order = `[["${order.column}", "${order.direction}"]]`;

        // Date Range
        if (range?.start && range?.end) x.daterange = `["${range.start}", "${range.end}"]`;
        else delete x.daterange;
        x.datecolumn = "createdAt"
        return x;
    }

    // Render Page
    return (
        <ModelList
            model="Library"
            action={searchAlbum}
            restore={restoreAlbum}
            selector={FullAlbums}
            onSelect={handleSelect}
            variant={variant}
            defaultLimit={16}
            emptyRenderer={renderEmpty}
            filters={formatOtherFilters()}
            customRenderer={renderMediaCard}
            prepend={prepend}
            mobileColumns={2}
            paginationControls={renderCustomControls}
        />
    )
}